import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = 'Gulf Digital - Your Trusted Cybersecurity Partner',
  description = 'Leading cybersecurity partner offering advanced solutions, 24/7 SOC services, and compliance advisory for businesses across Saudi Arabia and the Middle East.',
  keywords = 'cybersecurity, Gulf Digital, SOC, DDoS protection, dark web monitoring, IAM, PAM, CIAM, Saudi Arabia, Middle East, cybersecurity services',
  image = '/assets/og-image.png',
  url = '',
  type = 'website',
  author = 'Gulf Digital',
  ogTitle,
  ogDescription,
  twitterTitle,
  twitterDescription
}) => {
  const resolvedOgTitle = ogTitle || title;
  const resolvedOgDescription = ogDescription || description;
  const resolvedTwitterTitle = twitterTitle || title;
  const resolvedTwitterDescription = twitterDescription || description;
  const siteUrl = 'https://gulfdigital-me.com';
  const fullUrl = url ? `${siteUrl}${url}` : siteUrl;
  const fullImage = image.startsWith('http') ? image : `${siteUrl}${image}`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <meta name="googlebot" content="index, follow" />
      <meta name="bingbot" content="index, follow" />
      <meta name="revisit-after" content="7 days" />
      <meta name="distribution" content="global" />
      <meta name="language" content="English" />
      <meta httpEquiv="Content-Language" content="en" />
      <meta name="theme-color" content="#8B3A3A" />
      <meta name="format-detection" content="telephone=no" />
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph (Facebook, LinkedIn, WhatsApp) */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={resolvedOgTitle} />
      <meta property="og:description" content={resolvedOgDescription} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:type" content="image/png" />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:site_name" content="Gulf Digital" />
      <meta property="og:locale" content="en_US" />
      <meta name="geo.region" content="SA" />
      <meta name="geo.placename" content="Saudi Arabia" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={resolvedTwitterTitle} />
      <meta name="twitter:description" content={resolvedTwitterDescription} />
      <meta name="twitter:image" content={fullImage} />
      <meta name="twitter:creator" content="@GulfDigital" />
      <meta name="twitter:site" content="@GulfDigital" />

      {/* Additional SEO */}
      <meta name="viewport" content="width=device-width, initial-scale=1, viewport-fit=cover" />
      
      {/* Schema.org markup for consistency */}
      <meta property="og:image:alt" content="Gulf Digital - Cybersecurity Solutions" />
      <meta name="twitter:image:alt" content="Gulf Digital - Cybersecurity Solutions" />
      
      {/* Preconnect to external domains */}
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
    </Helmet>
  );
};

export default SEO;